import React from 'react';
import { Box, Container } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Button, Typography } from '@tkww/the-bash-frontend';

import ProfileSummary from 'views/ProfileReviewsPage/ProfileSummary';
import ReviewsWidgetSection from 'components/Reviews/ReviewsWidgetSection';
import { profileReviewsPropTypes } from 'propTypes/profileReviews';
import { gmConfig } from 'helpers/config';
import { COMPACT_WIDGET_REVIEWS_PAGE, reviewTypes } from 'constants/Profiles';

const StyledButton = styled(Button)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('md')]: {
    maxWidth: 208,
  },
}));

const WidgetReviewsPage = ({ profile, pageType, query: originalQuery }) => {
  const { profileName, profileUrl } = profile;
  const destinationUrl = `https://${gmConfig.domains.www}${profileUrl}#reviews`;
  const widgetType =
    pageType === COMPACT_WIDGET_REVIEWS_PAGE ? reviewTypes.compact : reviewTypes.widget;
  return (
    <>
      <Container maxWidth="md">
        <Typography
          variant="h1"
          sx={{
            marginTop: 1.5,
            marginBottom: '18px',
          }}
        >
          {profileName} Reviews
        </Typography>
        <ProfileSummary
          profile={profile}
          type="widget"
          sxDetails={{ padding: 0 }}
          detailsList={{ marginBottom: 0 }}
        />
        <ReviewsWidgetSection profile={profile} type={widgetType} originalQuery={originalQuery} />
        <Box
          sx={{ display: 'flex', justifyContent: 'center', marginBottom: 7, width: '100%' }}
          data-testid="read-more-container"
        >
          <StyledButton path={destinationUrl} target="_blank">
            Read More
          </StyledButton>
        </Box>
      </Container>
    </>
  );
};

WidgetReviewsPage.propTypes = profileReviewsPropTypes;

export default WidgetReviewsPage;
